/**
 * All test utils are based on guidance from here: https://formatjs.io/docs/guides/testing/
 */

import React from 'react';
import type { DecoratorFn } from '@storybook/react';
import {
	createIntl,
	createIntlCache,
	IntlProvider as IntlNextProvider,
	getRelativeTimeAndUnit,
	type IntlShapeV2,
} from '@atlassian/jira-intl';

export const defaultLocale = 'en';
const locale = defaultLocale;
export const IntlProvider = IntlNextProvider;

const cache = createIntlCache();

export const intl = createIntl(
	{
		locale: 'en',
		messages: {},
	},
	cache,
);

export const intlV2: IntlShapeV2 = {
	// Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
	now: () => Date.now(),
	// @ts-expect-error Type 'MessageFormatElement[]' is not assignable to type 'string'.
	messages: intl.messages,
	locale: intl.locale,
	formats: intl.formats,
	formatDate: intl.formatDate,
	formatMessage: intl.formatMessage,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	formatHTMLMessage: (descriptor: any, values: any) =>
		intl.formatMessage(descriptor, values, { ignoreTag: true }),
	formatNumber: intl.formatNumber,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	formatRelative: (date: any, opts: any) => {
		const { time, unit } = getRelativeTimeAndUnit(date);
		return intl.formatRelativeTime(time, unit, opts);
	},
	formatPlural: intl.formatPlural,
	formatTime: intl.formatTime,
};

// @ts-expect-error - TS2304 - Cannot find name 'MessageDescriptorV2'.
const formatMessage = (message: MessageDescriptorV2) => message.defaultMessage || '';
const noopFormat = () => '';

export const initialIntlV2: IntlShapeV2 = {
	formatDate: noopFormat,
	formatTime: noopFormat,
	formatRelative: noopFormat,
	formatNumber: noopFormat,
	formatPlural: noopFormat,
	formatMessage,
	formatHTMLMessage: noopFormat,
	formats: {},
	locale: '',
	messages: {},
	now: () => -1,
};

export const mockUseIntlV2 = () => intlV2;

// Storybook decorator for useIntl()
export const withUseIntlV2: () => DecoratorFn = () => (story) => (
	<IntlNextProvider locale={locale}>{story()}</IntlNextProvider>
);
